import { render, staticRenderFns } from "./index.vue?vue&type=template&id=797e53f4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=797e53f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e53f4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ThemeStoresMobileAndroidAppSection: require('/app/components/ThemeStores/Mobile/Android/AppSection.vue').default,ThemeStoresMobileAndroidScreenshots: require('/app/components/ThemeStores/Mobile/Android/Screenshots.vue').default,ThemeStoresMobileAndroidAboutAndPrivacy: require('/app/components/ThemeStores/Mobile/Android/AboutAndPrivacy.vue').default,ThemeStoresMobileAndroidRatingDisplay: require('/app/components/ThemeStores/Mobile/Android/RatingDisplay.vue').default,ThemeStoresMobileAndroidComments: require('/app/components/ThemeStores/Mobile/Android/Comments.vue').default,ThemeStoresMobileAndroidFooter: require('/app/components/ThemeStores/Mobile/Android/Footer.vue').default})
